export const theme = {
  colors: {
    background: '#2B2B2B',
    header: '#F0141E',
    headerText: '#FCE0E3',
    cardText: '#FCE0E3',
    veryHightPriority: '#F0141E',
    hightPriority: '#8BBF00',
    lowPriority: '#08A7F9',
  },
  boxShadow: {
    sm: '0px 1px 4px #15223214',
    md: '3px 3px 15px #00000044',
  },
  spacing: {
    xxs: '4px',
    xs: '8px',
    sm: '16px',
    xsm: '20px',
    md: '24px',
    lg: '32px',
    xlg: '48px',
    xxlg: '64px',
    none: '0px',
  },
  borderRadius: {
    xs: '2px',
    sm: '4px',
    md: '8px',
    lg: '12px',
  },
  breakpoints: {
    laptop: '1440px',
    tablet: '768px',
    mobile: '375px',
  },
};
